import script from "./Voter-card-design.vue?vue&type=script&setup=true&lang=js"
export * from "./Voter-card-design.vue?vue&type=script&setup=true&lang=js"

import "./Voter-card-design.vue?vue&type=style&index=0&id=4c5d21b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c5d21b6"]])

export default __exports__